import { Button, Col, Row, Typography } from 'antd';
import moment from 'moment';
import { Colors } from 'works/legacy/lib/style-helper';
import React from 'react';
import { ShiftGapDetailsQueryCgResponse } from '@common/graphql/schema';
import { Icon } from '@common/components';

const { Text } = Typography;

export function ShiftRequestDetailsContent({
  shift,
  setShiftEditMode = () => {},
  showOpeningCount,
  matchBreakdownEditMode = false,
  canEditShiftDetails = false,
  tagsEnabled = false,
}: {
  shift: ShiftGapDetailsQueryCgResponse['shiftGap'];
  showOpeningCount?: boolean;
  setShiftEditMode?: (value: boolean) => void;
  matchBreakdownEditMode?: boolean;
  canEditShiftDetails?: boolean;
  tagsEnabled?: boolean;
}) {
  const isNightShift = shift.timeOfDay === 'night';

  const shiftStart = moment.utc(shift.startDatetime).tz(shift.timeZone);
  const shiftEnd = moment.utc(shift.endDatetime).tz(shift.timeZone);

  const shiftRangeText = `${shiftStart.format('HH:mm')} - ${shiftEnd.format(
    'HH:mm'
  )}`;

  const titleSpan = showOpeningCount ? 4 : 3;

  return (
    <>
      <Row gutter={[8, 20]} align="middle">
        <Col>
          <Text style={{ fontSize: 16, fontWeight: 500 }}>
            {shiftStart.format('dddd, MMMM D')}{' '}
          </Text>
        </Col>
        <Col>
          <Icon
            icon={isNightShift ? 'moon' : 'sun'}
            kind="solid"
            size="md"
            color={isNightShift ? 'skyRegular' : 'harvestGold'}
          />
        </Col>
        <Col>
          <Text style={{ fontSize: 16, fontWeight: 500 }}>
            {shiftRangeText} (
            {Number(shift.shiftDuration).toLocaleString('fullwide', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}{' '}
            hrs)
          </Text>
        </Col>
        {(canEditShiftDetails || tagsEnabled) && !matchBreakdownEditMode && (
          <Button type="link" onClick={() => setShiftEditMode(true)}>
            <Icon icon="pen" kind="solid" size="md" />
          </Button>
        )}
      </Row>
      <div style={{ fontSize: '14px', marginTop: '16px' }}>
        <Row gutter={[0, 8]}>
          <Col span={titleSpan}>
            <Text type="secondary">Role</Text>
          </Col>
          <Col span={16}>{shift?.role?.abbreviation}</Col>
        </Row>

        <Row gutter={[0, 8]} style={{ marginTop: 12 }}>
          <Col span={titleSpan}>
            <Text type="secondary">Unit</Text>
          </Col>
          <Col span={16}>{shift.organizationUnit.name}</Col>
        </Row>

        <Row gutter={[0, 8]} style={{ marginTop: 12 }}>
          <Col span={titleSpan}>
            <Text type="secondary">CC</Text>
          </Col>
          <Col span={16}>{shift.organizationUnit.costCenter}</Col>
        </Row>

        {showOpeningCount && (
          <Row gutter={[0, 8]} style={{ marginTop: 12 }}>
            <Col span={titleSpan}>
              <Text type="secondary">Openings</Text>
            </Col>
            <Col span={24 - titleSpan}>{shift.openShiftGapOpeningsCount}</Col>
          </Row>
        )}

        {tagsEnabled && (
          <Row gutter={[0, 8]} style={{ marginTop: 12 }}>
            <Col span={titleSpan}>
              <Text type="secondary">Tags</Text>
            </Col>
            {shift.shiftGapTags &&
              shift.shiftGapTags.map((tag) => (
                <div
                  key={tag.id}
                  style={{
                    backgroundColor: Colors.skyLightest,
                    cursor: 'pointer',
                    marginRight: 8,
                    padding: '0px 12px',
                    borderRadius: 24,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Text style={{ fontWeight: 400 }}>{tag.name}</Text>
                </div>
              ))}
            {!shift.shiftGapTags?.length && <Col span={16}>None</Col>}
          </Row>
        )}
      </div>
    </>
  );
}
